  <form id="confirma-datos" class="row form-confirmation-styles first-container-identification-xs m-t-34 m-t-xs-44 m-b-29 form-width-size" [formGroup]="form" (ngSubmit)="saveDataConfirmation($event)" autocomplete="off">
    <div class="  col-12 m-b-36 m-b-xs-40 d-flex justify-content-between align-items-start">
      <div class="container-return-style align-self-start">
        <img class="img-return-blue" id ='img-return-blue' [src]="url_img.return_blue" alt="" (click)="previous('I')">
      </div>
      <app-header-steps></app-header-steps>
    </div>
    <div class="col-12 m-b-40 m-b-sm-30 m-b-xs-40">
      <div class="">
        <div class="d-block w-100">
          <p class=" heading-b-b-26 text-start line-height-33 text-start mb-0">
            Confirma tus datos
          </p>
        </div>
      </div>
    </div>
    <div class="col-9 col-md-10 m-b-31">
      <p class="paragraph-b-b-16 mb-0 text-start line-height-20">
        Datos generales
      </p>
    </div>
    <div class="col-3 col-md-2 m-b-20 text-end">
      <a class="link-generic-style  line-height-20" routerLink="/registro" (click)="gtag('DatosGenerales')">Editar</a>
    </div>
    <div class="col-12 m-b-40">
      <p class=" paragraph-b-r-16 mb-0 text-start line-height-20">
        Mi nombre es <span>{{generalData.cx_nombre+' '+generalData.cx_apellido_p+' '+generalData.cx_apellido_m | titlecase}}</span>, mi celular es <span>{{generalData.int_telefono}}</span>  y mi email es <span>{{generalData.cx_correo | lowercase}}</span> 
      </p>
    </div>
    <div class="w-100 d-block"></div>
    <div class="col-9 col-md-10 m-b-31">
        <p class="paragraph-b-b-16 mb-0 text-start line-height-20">
            Datos personales y laborales
        </p>
      </div>
      <div class="col-3 col-md-2 m-b-20 text-end">
        <a class="link-generic-style  line-height-20" routerLink="/opciones/autonomo-completa-informacion" (click)="gtag('DatosPersonales')">Editar</a>
      </div>  
      <div class="col-12 m-b-40">
        <p class=" paragraph-b-r-16 mb-0 text-start line-height-20">
            Estoy {{occupationData.cx_edo_civil | titlecase}} 
            Mi CURP es <span>{{occupationData.cx_curp}}</span> 
            Mi RFC es <span>{{occupationData.cx_rfc_tin}}</span> 
            <span *ngIf="showOccupation">Trabajo como {{occupationData.puesto | titlecase}} en {{occupationData.nombreEmpresa | titlecase}} y mi profesión es {{occupationData.cx_profesion | titlecase}}.</span>
            <span *ngIf="!showOccupation"> Soy {{occupationData.cx_ocupacion | titlecase}}.</span>
        </p>
      </div>
      <div class="w-100 d-block"></div>
      <div class="col-9 col-md-10 m-b-31" *ngIf="showBeneficiary">
        <p class="paragraph-b-b-16 mb-0 text-start line-height-20">
            Beneficiario
        </p>
      </div>
      <div class="col-3 col-md-2 m-b-20 text-end" *ngIf="showBeneficiary">
        <a class="link-generic-style  line-height-20" routerLink="/opciones/autonomo-beneficiario" (click)="gtag('Beneficiario')">Editar</a>
      </div>  
      <div class="col-12 m-b-40" *ngIf="showBeneficiary">
        <p class=" paragraph-b-r-16 mb-0 text-start line-height-20">
            Es <span> {{beneficiaryData.nombre+' '+beneficiaryData.aPaterno+' '+beneficiaryData.aMaterno | titlecase}}</span>. 
            Nació el <span>{{beneficiaryData.fechaNacimientoBnfcrDp}}.</span> 
            <span *ngIf="showBeneficiaryAddress">Vive en  {{beneficiaryData.calle | titlecase}}, {{beneficiaryData.numeroExt}},<span *ngIf="beneficiaryData.numeroInt!=''">{{' '+beneficiaryData.numeroInt+', '}}</span> Col. {{beneficiaryData.colonia | titlecase}}, {{beneficiaryData.delegacion | titlecase}}, {{beneficiaryData.ciudadTxt | titlecase}}, {{beneficiaryData.estado | titlecase}}, {{beneficiaryData.paisTxt | titlecase}}, C.P. {{beneficiaryData.codigoPostal}}.</span>
            <span *ngIf="!showBeneficiaryAddress">Vive en mismo domicilio que el titular 

            </span> 
         </p>
      </div>
      <div class="w-100 d-block"></div>
      <div class="col-9 col-md-10 m-b-20">
        <p class="paragraph-b-b-16 mb-0 text-start line-height-20">
        Identificación oficial
        </p>
      </div>
      <div class="col-3 col-md-2 m-b-20 text-end">
        <a class="link-generic-style  line-height-20" routerLink="/opciones/autonomo-identificacion" (click)="gtag('Identificación')">Editar</a>
      </div>  
      <div class="col-12 m-b-20">
        <div class="container-photo-style m-b-20" *ngIf="showImgOne()">
            <img class="img-id-front" [src]="img_front" alt="">
            <img class="img-arrows-white" [src]="url_img.arrows_white" alt="" (click)="openModalFront(content)">
        </div>
        <div class="container-pdf-style m-b-20" *ngIf="showPDFOne()">
          <img class="img-pdf-blue" [src]="url_img.pdf_blue" alt=""><span class="text-pdf-blue p-l-10"><span class="">{{identificationData.cx_nombre_identificacion}}</span></span>
        </div>
        <div class="container-photo-style m-b-20" *ngIf="showImgTwo()">
            <img class="img-id-front" [src]="img_reverse" alt="">
            <img class="img-arrows-white" [src]="url_img.arrows_white" alt="" (click)="openModalReverse(content)">
        </div>
        <div class="container-pdf-style m-b-20" *ngIf="showPDFTwo()">
          <img class="img-pdf-blue" [src]="url_img.pdf_blue" alt=""><span class="text-pdf-blue p-l-10"><span class="">{{identificationData.cx_nombre_rfc}}</span></span>
        </div>        
      </div>
      <div class="w-100 d-block"></div>
      <div class="  col-9 col-md-10 m-b-20" *ngIf="showProofAddress">
        <p class="paragraph-b-b-16 mb-0 text-start line-height-20">
            Comprobante de domicilio
        </p>
      </div>
      <div class="col-3 col-md-2 m-b-20 text-end" *ngIf="showProofAddress">
        <a class="link-generic-style  line-height-20" routerLink="/opciones/autonomo-comprobante" (click)="gtag('ComprobanteDomicilio')">Editar</a>
      </div>  
      <div class="col-12 m-b-40" *ngIf="showProofAddress">
          <!--!opcion que se muestra cuando hay imagen-->
        <div class="container-photo-style" *ngIf="showImgProof()">
            <img class="img-id-front" [src]="img_proof" alt="">
            <img class="img-arrows-white" [src]="url_img.arrows_white" alt="" (click)="openModalProofAddress(content)">
        </div>
        <!--!opcion que se muestra cuando hay pdf-->
        <div class="container-pdf-style" *ngIf="showPDFProof()">
            <img class="img-pdf-blue" [src]="url_img.pdf_blue" alt=""><span class="text-pdf-blue p-l-10"><span class="">{{proofAddressData.cx_nombre_documento}}</span></span>
        </div>
      </div>
      <div class="w-100 d-block"></div>
      <div class="col-10 col-md-10 m-b-31">
        <p class="paragraph-b-b-16 mb-0 text-start line-height-20">
          Al continuar acepto:
        </p>
      </div>

      <div class="list__terms col-12">       
        <div class="terms__item">
          <div class="item__check">
            <img class="icon__check" [src]="url_img.check__slim" alt="">
          </div>
          <div class="item__paragraph">
            <p class="item__text">Los recursos a invertir en Bursanet son míos.</p>
          </div>
        </div>
        <div class="terms__item">
          <div class="item__check">
            <img class="icon__check" [src]="url_img.check__slim" alt="">
          </div>
          <div class="item__paragraph">
            <p class="item__text">Actúo a mi nombre y cuenta propia.</p>
          </div>
        </div>
        <div class="terms__item">
          <div class="item__check">
            <img class="icon__check" [src]="url_img.check__slim" alt="">
          </div>
          <div class="item__paragraph">
            <p class="item__text">Los <a class="text__link" [href]="url.documents.terminos" target="_blank">términos, condiciones</a>  y el <br class="d-block d-sm-none"> <a class="text__link" target="_blank" [href]="url.documents.aviso">aviso de privacidad</a>.</p>
          </div>
        </div>
      

      </div>

      <div class="w-100 d-block"></div>
    <div class="col-6  text-start">
      <div class="m-b-29">
        <button class="button-generic-style button-outline height-48 w-100" (click)="previous('')">Regresar</button>
      </div>
    </div>
    <div class="col-6  text-end">
      <div class="m-b-29">
        <button class="button-generic-style button-blue height-48 w-100">Continuar</button>
      </div>
    </div>
  </form>
  <ng-template #content let-modal>
    <div class="modal-header">
      <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Close')">
        <img class="img-close-blue" [src]="url_img.close_blue" alt="">
      </button>
    </div>
    <div class="modal-body text-center">
      <img class="img-fluid" [src]="imgModal" alt="">
    </div>
  </ng-template>
